/*
 * Takes a video URL, wraps it in a instance of our default modal
 * and opens it when the user hits play
 *
 * Only supports YouTube embeds right now
 */
import MicroModal from 'micromodal'

import { createModal } from '../library/Modal'
import { createNewsletterForm } from '../library/VideoPlayer'

export default class WebinarModal {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.embed = this.el.dataset.embed
    this.style = 'modal__video'
    this.heading = false
    this.footer = false
    this.id = this.el.dataset.id
  }

  init() {
    const modal = createModal(this.id, {
      style: 'modal__signup',
      hasHeading: this.heading,
      hasFooter: this.footer,
    })
    const content = modal.querySelector('.modal__content')
    const form = createNewsletterForm(33)
    content.appendChild(form.wrapper)

    this.el.addEventListener('click', (event) => {
      event.preventDefault()
      MicroModal.show(this.id)
    })
  }
}
